<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editPhase') }}</h1>
      <div class="form-container">
        <PhaseForm @save="save"
                   :edit-mode="true"
                   :phase-data="phaseData">
        </PhaseForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import PhaseForm from '@/components/PhaseForm'

  export default {
    components: {
      DashboardLayout,
      PhaseForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Phase/update', {
          phase: form,
          projectId: this.$route.params.projectId
        }).then(() => {
          this.$router.push({
            name: 'projectDetail',
            params: {
              projectId: this.$route.params.projectId,
              section: 'phases'
            }
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Phase/getPhase', {
        projectId: this.$route.params.projectId,
        phaseId: this.$route.params.phaseId
      })
    },
    computed: {
      ...mapState('Phase', ['phase']),
      phaseData() {
        return {
          ...this.phase,
          start_date: new Date(this.phase.start_date),
          end_date: this.phase.end_date ? new Date(this.phase.end_date) : null,
          completed_date: this.phase.completed_date ? new Date(this.phase.completed_date) : null,
        }
      },
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail', path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'editPhase'}
        ]
      }
    }
  }
</script>